import React from 'react';
import { Users, Handshake, Heart, Globe, Check } from 'lucide-react';
import { whyChooseUs } from '../data/mock';

const iconMap = {
  Users,
  Handshake,
  Heart,
  Globe,
};

const WhyChooseUsSection = () => {
  return (
    <section id="why-us" className="py-24 bg-charcoal relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `radial-gradient(circle at 2px 2px, rgba(201, 162, 77, 0.3) 1px, transparent 0)`,
            backgroundSize: '40px 40px',
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-12 h-0.5 bg-gold" />
            <span className="text-gold text-sm tracking-widest uppercase font-medium">
              Our Difference
            </span>
            <div className="w-12 h-0.5 bg-gold" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-ivory mb-6">
            Why Choose Nora Gold Advisory
          </h2>
          <p className="text-slate text-lg max-w-2xl mx-auto">
            Partner with a firm that combines deep expertise with practical,
            results-driven advisory support.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {whyChooseUs.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div
                key={item.id}
                className="group flex gap-6 p-8 bg-charcoal border border-slate/20 hover:border-gold/40 transition-all duration-500"
              >
                {/* Icon */}
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 bg-burgundy/20 flex items-center justify-center group-hover:bg-burgundy transition-colors duration-300">
                    {IconComponent && (
                      <IconComponent
                        className="text-gold group-hover:text-ivory transition-colors duration-300"
                        size={28}
                      />
                    )}
                  </div>
                </div>

                {/* Content */}
                <div>
                  <h3 className="text-xl font-bold text-ivory mb-3 group-hover:text-gold transition-colors duration-300">
                    {item.title}
                  </h3>
                  <p className="text-slate leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
